<figure class="preview-container">
  <ul class="layers">
    @for (_ of [].constructor(doorNumber); track $index) {
      <li class="sublayer">
        <img src="assets/img/closet-doors/layers/900/1P_Noir_900.png" alt="" />
      </li>
    }
  </ul>
</figure>
<div class="preview-floor"></div>
